export default __webpack_public_path__ + "static/media/clapping_hands.641113a2.svg";